import { Skeleton } from './Skeleton'
import { TableSkeleton } from './TableSkeleton'

export function DashboardSkeleton() {
    return (
        <div className="flex flex-col gap-y-6">
            {/* key metric placeholder */}
            <div className="rounded-lg border border-gray-300 px-6 py-4">
                <Skeleton width={60} height={32} borderRadius={8} />
                <Skeleton width={116} height={24} borderRadius={8} />
            </div>

            <TableSkeleton />
        </div>
    )
}
